import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/app-store-badge-en.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')